import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./DataTextModel";
import AutoRefreshDiagramUI from '../AutoRefreshDiagramUI';
import { Spin } from 'antd';

export default class UI extends AutoRefreshDiagramUI {

    state = {

    };

    constructor(props, context) {
        super(props, context);
    }

    needRefresh() {
        this.props.model.refreshData();
    }

    render() {
        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={{
                ...this.props.model.toStyle(),
                position: "relative"
            }}  >
                <div className="abs-0" style={{
                    display: "none",
                    // display: this.props.model.asyncLoading ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#0000001a",

                }}>
                    <Spin></Spin>
                </div>
                {this.props.model.text}
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "数据文本框",
    catalog: "图表（已废弃）",
    catalogIndex: 999999999,
    svg: "#anticon-component-rich-text",
    uiGetter: (model) => <UI model={model} />
});